var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapLakeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.51,
    height: 17.5,
    viewBox: "0 0 19.51 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "t",
    transform: "translate(-2.24 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M19,5.25H15.32a1.386,1.386,0,0,1-.4-.06L9.54,3.39a2.83,2.83,0,0,0-.87-.14H4.99A2.748,2.748,0,0,0,2.24,6V16a2.748,2.748,0,0,0,2.75,2.75H8.67a1.386,1.386,0,0,1,.4.06l5.38,1.8a2.83,2.83,0,0,0,.87.14H19A2.748,2.748,0,0,0,21.75,18V8A2.748,2.748,0,0,0,19,5.25ZM20.25,18A1.25,1.25,0,0,1,19,19.25H15.32a1.386,1.386,0,0,1-.4-.06L9.74,17.46V8a.75.75,0,0,0-1.5,0v9.25H4.99A1.25,1.25,0,0,1,3.74,16V6A1.25,1.25,0,0,1,4.99,4.75H8.67a1.386,1.386,0,0,1,.4.06l5.18,1.73V16a.75.75,0,0,0,1.5,0V6.75H19A1.25,1.25,0,0,1,20.25,8Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLakeIcon);
export default __webpack_public_path__ + "static/media/mapLakeIcon.ccc7c52be2aa9f33ec49a7b6d191d034.svg";
export { ForwardRef as ReactComponent };